import { TranslationRepository } from '../data/translation-repository';
import { ApplicationType, BulkImportResult, ImportMode } from '../types/translation-types';

export class BulkImportUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(
    applicationType: ApplicationType,
    file: File,
    mode: ImportMode
  ): Promise<BulkImportResult> {
    return this.repository.bulkImport(applicationType, file, mode);
  }
}
